import { NavLink as RouterNavLink } from 'react-router-dom';
import { cn } from '@/design/utils/cn';

interface NavLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
}

export const NavLink = ({ to, children, className }: NavLinkProps) => {
  return (
    <RouterNavLink
      to={to}
      className={({ isActive }) =>
        cn(
          'text-gray-600 hover:text-gray-900 transition-colors duration-200 font-medium',
          isActive && 'text-brand-primary',
          className
        )
      }
    >
      {children}
    </RouterNavLink>
  );
};
